<template>
  <div>
        <Modal
            :mask-closable="false"
            v-model="group.ModalGroupList"
            title="组别设置"
            width="760"
            :footerHide="true"
        >
            <div class="mainListT cf">
                <Button class="float-l" type="primary" size="small" icon="md-add"  @click="addGroup">新增组别</Button>
            </div>
            <div class="GroupListTable">
                <Table border :columns="GroupregisterColumns" :data="group.GroupregisterData" ></Table>
            </div>
            <div class="GroupUpBut cf">
                <Button class="float-r" type="primary" @click="goEvent" size="large"  >下一步</Button>
            </div>
            
        </Modal>
        <Modal
            :mask-closable="false"
            v-model="ModalGroup"
            title="新增组别名"
            width="360"
            :footerHide="true"
            @on-cancel="handleReset('formValiEditDateGroup')"
        >
            <Form  ref="formValiEditDateGroup" :model="formValiEditDateGroup" :rules="ruleValidateGroup" :label-width="120" >
                <div class="editDiv">
                    <div class="fromDiv" >
                        <div class="fromDiv_l cf">
                            <div class="attention">注意：新增组别中文名格式（例如 “甲” 填写为 “甲组” ）</div>
                            <FormItem label="组别中文名称：" prop="sortNameCHN">
                                <Input  placeholder="" v-model="formValiEditDateGroup.sortNameCHN"></Input>
                            </FormItem>
                            <FormItem label="组别英文名称：" prop="sortNameENG">
                                    <Input   placeholder="" v-model="formValiEditDateGroup.sortNameENG"></Input>
                            </FormItem>
                            <FormItem label="组别类型：" prop="sortType">
                                <Select v-model="formValiEditDateGroup.sortType">
                                    <Option v-for="item in $PlugIn.SortNameENGData" :value="item.value" :key="item.value">{{ item.label }}</Option>
                                </Select>
                            </FormItem>
                        </div>
                    </div>
                    <div class="UpBut">
                        <Button class="m-r10px" type="primary" size="large" :disabled="disableds"   @click="GroupSubmit('formValiEditDateGroup')">保存</Button>
                    </div>
                </div>
            </Form>
        </Modal>
  </div>
</template>

<script>
import {getSort,addSort,addSexsort,getSexsortList,delGroup} from '@/lib/api/index.js'

let requiredStr = '必选项不能为空！'
export default {
  props: ['gameId','group'],
  data(){
    return {
           //组别名称
        disableds:false,
        setType:0,
        GroupregisterColumns:[
                {
                    type:'index',
                    title: '序号',
                    width:70,
                    align:'center',

                }, 
                {
                    key: 'sortNameCHN',

                    title: '组别（中）',

                },
                {
                    key: 'sortNameENG',
                    title: '组别（英）',

                },
                {
                    title: '操作',
                    align: 'center',
                    width: 136,
                    render: (h, params) => {
                            return h('div',{
                                style: {
                                    paddingTop: '6px',
                                    paddingBottom: '6px',
                                    
                                }
                            },[
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        marginRight: '5px',
                                    },
                                    on: {
                                        click: () => {
                                            this.ModalGroup=true;
                                            this.setType = 1;
                                            
                                            this.formValiEditDateGroup =  this.$PlugIn.deepClone(params.row);
                                        }
                                    }
                                }, '编辑'),
                                h('Button', {
                                    
                                    props: {
                                        size: 'small',
                                        type: 'error',
                                    },
                                    style: {
                                        marginRight: '5px',
                                    },
                                    on: {
                                        click: () => {
                                            this.$Modal.confirm({
                                                title: '提示',
                                                content: '<p>您确定要删除吗？</p>',
                                                onOk: () => {
                                                    this.removeGroup(params);
                                                }
                                            });
                                            
                                        }
                                    }
                                }, '删除'),
                                
                            ]);

                    }
                }
        ],
        // GroupregisterData:[],
        ModalGroupList:false,
        ModalGroup:false,
        formValiEditDateGroup:{
            sortNameCHN:'',
            sortNameENG:'',
            sortType:'',
            sex:''
        },
        ruleValidateGroup:{
            sortNameCHN:[
                { required: true, message: requiredStr, trigger: 'blur' }
            ],
            sortType: [
                { required: true, message: requiredStr, trigger: 'blur' ,type: 'number'}
            ],
            sex: [
                { required: true, message: requiredStr, trigger: 'blur' ,type: 'number'}
            ],
         
        },
    }
  },
  computed:{
    getGameNames(){
      return this.$store.state.unitAllData.gameName
    }
  },
  methods:{
      removeGroup(obj)
      {          
          delGroup(obj.row.sortID).then(res => {
          
                if(res.data.code == 0){
                    this.$Message.info("删除成功");
                    
                    getSort(this.gameId).then(res => {
                        if(res.data.code == 0){
                            this.$emit('GroupregisterDataUp',res.data.data)
                        }else if(res.data.code == -2){
                            this.$Message.error("网络连接失败");
                        }else if(res.data.code==10)
                        {
                            this.$Message.info("登录token过期请重新登录");
                            this.$store.dispatch('loginOut');
                        }else{
                            this.$Message.error(res.data.msg);
                        }
                    },err =>{
                        this.$Message.error("网络连接失败");
                    });
                }else if(res.data.code == -2){
                    this.$Message.error("删除失败");
                }else if(res.data.code==10)
                {
                    this.$Message.info("登录token过期请重新登录");
                    this.$store.dispatch('loginOut');
                }else{
                    this.$Message.error(res.data.msg);
                    
                }
            },err =>{
                this.$Message.error("网络连接失败");
            });
      },
      GroupSubmit(name)//新增组别
      {
           
           this.$refs[name].validate((valid) => { 
                if (valid) {
                        this.disableds = true;
                        this.loadings();
                        let updSporterData = this.$PlugIn.deepClone(this.formValiEditDateGroup);
                        updSporterData.gameID = updSporterData.gameID ? updSporterData.gameID : this.gameId;

                        updSporterData.sortID = this.setType===1 ? updSporterData.sortID : -1;
               
                        addSort(updSporterData).then(res => {//新增
                            if(res.data.code == 0){
                                this.$emit('GroupList');
                                if(updSporterData.sortID==-1)
                                {
                                  this.$Message.info("添加成功");
                                }else{
                                  this.$Message.info("编辑成功");
                                }
                                this.ModalGroup = false;
                                this.disableds = false;
                                this.handleReset (name);
                                this.$Spin.hide();
                            }else if(res.data.code == -2){
                                this.$Message.error("添加失败");
                                this.disableds = false;
                                this.$Spin.hide();
                            }else if(res.data.code==10)
                            {
                                this.$Message.info("登录token过期请重新登录");
                                this.$store.dispatch('loginOut');
                            }else{
                                this.$Message.error(res.data.msg);
                                this.disableds = false;
                                this.$Spin.hide();
                            }
                        },err =>{
                            this.$Message.error("网络连接失败");
                            this.$Spin.hide();
                        });
                } else {
                    this.$Message.error('请完善信息');
                    this.$Spin.hide();
                }
            });
      },
      addGroup()
      {
          this.ModalGroup=true;
          this.setType = 0;
      },
      goEvent()
      {
        
        this.$emit('sexGroupListShow');
      }
  },
  created(){},
  mounted(){
  }
}
</script>
<style scoped  lang="less">
    .attention{padding-bottom: 12px;color: #ed4014;}
    .GroupUpBut{
      padding-top: 22px;
    }
    .mainListT{margin-bottom: 12px; line-height: 24px;;}
</style>


// WEBPACK FOOTER //
// src/components/group.vue